<div class="container">
    <h2>Use this selfie or click camera to retake</h2>
    
    <div class="camera-preview">
      <!-- Placeholder for the selfie preview -->
      <div class="snapshot" *ngIf="appservice.Selfie_Image"><img  [src]="appservice.Selfie_Image" /></div>
      <img *ngIf="!appservice.Selfie_Image" class="image" [height]="150" [width]="200"
        src="{{appservice.Server_URL}}/image/V{{appservice.Company_}}/V{{Contact_No}}.png" 
        (error)="img.src = '../../assets/img/empty.png'" #img />
      
    </div>
  
    <div class="buttons">
      <button (click)="take_photo()" class="camera-btn">
        <i class="mdi mdi-camera"></i>
      </button>
    </div>
  
    <div class="action-buttons">
      <button (click)="appservice.back()">Back</button>
      <button (click)="addData()">Next</button>
    </div>
  
  </div>
  